module.exports = __webpack_public_path__ + "static/media/video-recorder-svgrepo-com.d3fe4242.svg";